/**
 * Cuelga un elemento de <body> mientras dura la pantalla completa y lo regresa
 * a su lugar exacto al salir.
 *
 * Hace falta este rodeo porque la pestaña activa de Material trae
 * position:relative con z-index:1, y eso abre un contexto de apilamiento:
 * cualquier cosa que se dibuje dentro se queda en ese nivel por más z-index
 * que se le ponga, y el menú lateral y la barra superior le pasan encima.
 * Fuera de la pestaña ya no hay nada que lo atrape.
 *
 * La clase mc-cuerpo-fijo (en styles.css) deja el fondo sin scroll mientras
 * tanto.
 */
export class PantallaCompleta {
  private padre: Node | null = null;
  private siguiente: Node | null = null;

  constructor(private readonly nodo: HTMLElement) {}

  private get fuera(): boolean {
    return this.nodo.parentNode === document.body;
  }

  /** Cuelga o regresa el nodo según lo que pida la pantalla. */
  sincronizar(debeSalir: boolean): void {
    if (debeSalir && !this.fuera) {
      this.padre = this.nodo.parentNode;
      this.siguiente = this.nodo.nextSibling;
      document.body.appendChild(this.nodo);
      document.body.classList.add("mc-cuerpo-fijo");
    } else if (!debeSalir && this.fuera) {
      this.regresar();
    }
  }

  /**
   * Al destruir el componente. Si el nodo sigue colgado de <body>, Angular ya
   * no lo va a quitar (solo desancla los nodos raíz de la vista, y este quedó
   * fuera de ella): sin esto, al navegar con la pantalla completa abierta el
   * overlay se quedaba muerto tapando la aplicación.
   */
  liberar(): void {
    document.body.classList.remove("mc-cuerpo-fijo");
    if (this.fuera) {
      this.nodo.remove();
    }
  }

  private regresar(): void {
    document.body.classList.remove("mc-cuerpo-fijo");
    if (!this.padre) {
      return;
    }
    // El hermano pudo haber desaparecido mientras tanto; entonces va al final.
    const hermano =
      this.siguiente && this.siguiente.parentNode === this.padre ? this.siguiente : null;
    this.padre.insertBefore(this.nodo, hermano);
    this.padre = null;
    this.siguiente = null;
  }
}
